import { render, staticRenderFns } from "./AttendAnEvent.vue?vue&type=template&id=300d23da&"
import script from "./AttendAnEvent.vue?vue&type=script&lang=ts&"
export * from "./AttendAnEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AttendAnEvent.vue"
export default component.exports